import cx from 'classnames';
import { observer, useLocalObservable } from 'mobx-react';

const PrivacyToggle = observer(
  ({ showLifetimeImpact, setShowLifetimeImpact }) => {
    const privacyToggleStore = useLocalObservable(() => ({
      showPrivacyOptions: false,
      toggle: function () {
        privacyToggleStore.showPrivacyOptions =
          !privacyToggleStore.showPrivacyOptions;
      },
    }));

    const updateUserShowLifetimeImpact = (value) => {
      $.ajax({
        method: 'PUT',
        url: '/account/settings',
        data: {
          user: {
            show_lifetime_impact: value,
          },
        },
        dataType: 'json',
        success: (data) => {
          setShowLifetimeImpact(data.user.show_lifetime_impact);
          setTimeout(privacyToggleStore.toggle, 750);
        },
      });
    };

    return (
      <div className='lifetime-impact-privacy-toggle relative ml-1'>
        <div
          className='button border border-solid border-grey-30 bg-cw-white text-grey-70 button--small'
          onClick={privacyToggleStore.toggle}
        >
          <i
            className={showLifetimeImpact ? 'cw-icon-globe' : 'cw-icon-lock'}
          />
          <span className='mx-1 current-show-lifetime-impact'>
            {showLifetimeImpact ? 'Public' : 'Private'}
          </span>
          <i className='cw-icon-caret-down' />
        </div>
        <ul
          className={cx(
            'absolute list-none z-10 bg-cw-white border border-solid border-grey-30 text-left font-xs p-0 cursor-pointer lifetime-impact-privacy-toggle-options',
            { hidden: !privacyToggleStore.showPrivacyOptions }
          )}
        >
          <li onClick={() => updateUserShowLifetimeImpact(false)}>
            <span
              className={cx(
                'hover-text-grey-60 inline-block p-2 text-grey-50',
                {
                  'text-grey-60': !showLifetimeImpact,
                }
              )}
            >
              <span className='toggle-option w-full inline-block font-medium'>
                <i className='cw-icon-lock' />
                <span className='inline-block uppercase font-xs ml-1'>
                  Private
                </span>
                <i
                  className={cx(
                    'cw-icon-ok float-right mr-2 lg-mr-0 text-cw-navy',
                    { hidden: showLifetimeImpact }
                  )}
                />
              </span>
              <p className='toggle-option-text m-0'>
                Your Lifetime Impact is only visible to you.
              </p>
            </span>
          </li>
          <li
            className='border border-solid border-grey-30 border-t border-l-0 border-r-0 border-b-0'
            onClick={() => updateUserShowLifetimeImpact(true)}
          >
            <span
              className={cx(
                'hover-text-grey-60 inline-block p-2 text-grey-50',
                {
                  'text-grey-60': showLifetimeImpact,
                }
              )}
            >
              <span className='toggle-option w-full inline-block font-medium'>
                <i className='cw-icon-globe' />
                <span className='uppercase font-xs ml-1'>Public</span>
                <i
                  className={cx(
                    'cw-icon-ok float-right mr-2 lg-mr-0 text-cw-navy',
                    { hidden: !showLifetimeImpact }
                  )}
                />
              </span>
              <p className='inline-block toggle-option-text m-0'>
                Display your Lifetime Impact on your public profile.
              </p>
            </span>
          </li>
        </ul>
      </div>
    );
  }
);

export default PrivacyToggle;
